export default {
  inserted: function (el,binding) {
    document.onmousemove=(e)=>{
       if(e.screenX>260){
        binding.value(true);
      }
    };
  }
}; 